import * as React from "react";
import { Component } from "react";
import { classNames } from "../utils.js";
import { KeyButton } from "./KeyButton.js";
import { IconNames, MaterialIcon } from "../icon.js";
import { classes, stylesheet } from "typestyle";
import { rem } from "csx";
function key(value, icon, width) {
    return {
        kind: "key",
        value: value,
        icon: icon,
        width: width
    };
}
function spacer(width) {
    return { kind: "spacer", width };
}
function caps(width) {
    return { kind: "caps", width };
}
function alt(width) {
    return { kind: "alt", width };
}
function abc(width) {
    return { kind: "abc", width };
}
export const GermanKeyboardLayout = {
    rows: [
        [key("1"), key("2"), key("3"), key("4"), key("5"), key("6"), key("7"), key("8"), key("9"), key("0"), key("ß"), /*key(String.fromCharCode(8), IconNames.backspace, 2)*/],
        [key("Q"), key("W"), key("E"), key("R"), key("T"), key("Z"), key("U"), key("I"), key("O"), key("P"), key("Ü"), spacer()],
        [key("A"), key("S"), key("D"), key("F"), key("G"), key("H"), key("J"), key("K"), key("L"), key("Ö"), key("Ä")],
        [key("Y"), key("X"), key("C"), key("V"), key("B"), key("N"), key("M"), key(" ", IconNames.space_bar, 3)],
    ]
};
export const NameKeyboardLayoutDE = {
    rows: [
        [key("Q"), key("W"), key("E"), key("R"), key("T"), key("Z"), key("U"), key("I"), key("O"), key("P"), key("Ü"), /*key(String.fromCharCode(8), IconNames.backspace, 2)*/],
        [key("A"), key("S"), key("D"), key("F"), key("G"), key("H"), key("J"), key("K"), key("L"), key("Ö"), key("Ä"), key("ß")],
        [key("Y"), key("X"), key("C"), key("V"), key("B"), key("N"), key("M"), key(" ", IconNames.space_bar, 4)],
    ]
};
export const EnglishKeyboardLayout = {
    rows: [
        [key("1"), key("2"), key("3"), key("4"), key("5"), key("6"), key("7"), key("8"), key("9"), key("0"), /*key(String.fromCharCode(8), IconNames.backspace, 2), spacer(1)*/],
        [key("Q"), key("W"), key("E"), key("R"), key("T"), key("Y"), key("U"), key("I"), key("O"), key("P"), spacer(), spacer()],
        [key("A"), key("S"), key("D"), key("F"), key("G"), key("H"), key("J"), key("K"), key("L"), spacer(), spacer()],
        [key("Z"), key("X"), key("C"), key("V"), key("B"), key("N"), key("M"), key(" ", IconNames.space_bar, 3)],
    ]
};
export const NameKeyboardLayoutEN = {
    rows: [
        [key("Q"), key("W"), key("E"), key("R"), key("T"), key("Y"), key("U"), key("I"), key("O"), key("P"), /*key(String.fromCharCode(8), IconNames.backspace, 2)*/],
        [key("A"), key("S"), key("D"), key("F"), key("G"), key("H"), key("J"), key("K"), key("L"), spacer(), spacer()],
        [key("Z"), key("X"), key("C"), key("V"), key("B"), key("N"), key("M"), key(" ", IconNames.space_bar, 3)],
    ]
};
export const PhoneKeyboardLayout = {
    rows: [
        [key("0"), key("1"), key("2"), key("3"), key(String.fromCharCode(8), IconNames.backspace, 1)],
        [key("+"), key("4"), key("5"), key("6"), spacer()],
        [spacer(), key("7"), key("8"), key("9"), spacer()],
    ]
};
export const EmailKeyboardLayout = createEmailKeyboardLayout(false);
export function createEmailKeyboardLayout(backspace) {
    const layout = {
        rows: [
            [key("@"), key("q"), key("w"), key("e"), key("r"), key("t"), key("z"), key("u"), key("i"), key("o"), key("p"), key("+")],
            [caps(1.5), key("a"), key("s"), key("d"), key("f"), key("g"), key("h"), key("j"), key("k"), key("l"), key("-"), spacer(0.5)],
            [alt(2), key("y"), key("x"), key("c"), key("v"), key("b"), key("n"), key("m"), key("."), key("_"), spacer()],
        ],
        alt: [
            [key("^"), key("1"), key("2"), key("3"), key("4"), key("5"), key("6"), key("7"), key("8"), key("9"), key("0"), spacer()],
            [caps(1.5), key("#"), key("%"), key("&"), key("="), key("|"), key("~"), key("*"), key("/"), spacer(), spacer(), spacer(0.5)],
            [alt(2), key("!"), key("$"), key("?"), key("{"), key("}"), key("\""), key("'"), key("`"), key("_"), spacer()],
        ],
    };
    if (backspace) {
        layout.rows[0].push(key(String.fromCharCode(8), IconNames.backspace, 1));
        layout.rows[1].push(spacer());
        layout.rows[2].push(spacer());
    }
    return layout;
}
export const CodeKeyboardLayout = {
    rows: [
        [key("1"), key("2"), key("3"), key("0"), spacer(1)],
        [key("4"), key("5"), key("6"), spacer(1), spacer(1)],
        [key("7"), key("8"), key("9"), abc(1.5), spacer(0.5)],
    ],
    alt: [
        [key("@"), key("q"), key("w"), key("e"), key("r"), key("t"), key("z"), key("u"), key("i"), key("o"), key("p"), key("+")],
        [caps(1.5), key("a"), key("s"), key("d"), key("f"), key("g"), key("h"), key("j"), key("k"), key("l"), key("-"), spacer(0.5)],
        [alt(2), key("y"), key("x"), key("c"), key("v"), key("b"), key("n"), key("m"), key("."), key("_"), spacer()],
    ]
};
export const TextKeyboardLayout = {
    rows: [
        [key("@"), key("q"), key("w"), key("e"), key("r"), key("t"), key("z"), key("u"), key("i"), key("o"), key("p"), key("+")],
        [caps(1.5), key("a"), key("s"), key("d"), key("f"), key("g"), key("h"), key("j"), key("k"), key("l"), key("-"), spacer(0.5)],
        [alt(2), key("y"), key("x"), key("c"), key("v"), key("b"), key("n"), key("m"), key(" ", IconNames.space_bar, 3)],
    ],
    alt: [
        [key("^"), key("1"), key("2"), key("3"), key("4"), key("5"), key("6"), key("7"), key("8"), key("9"), key("0"), spacer()],
        [caps(1.5), key("#"), key("%"), key("&"), key("="), key("|"), key("~"), key("*"), key("/"), key("."), key("_"), spacer(0.5)],
        [alt(2), key("!"), key("$"), key("?"), key("{"), key("}"), key("\""), key("'"), key("`"), key("_"), spacer()],
    ],
};
function toCaps(rows) {
    return rows.map(row => row.map(item => item.kind == "key" ? { ...item, value: item.value.toUpperCase() } : item));
}
export class Keyboard extends Component {
    constructor(props) {
        super(props);
        this.handleAlt = () => this.setState({ alt: !this.state.alt });
        this.handleCaps = () => this.setState({ caps: !this.state.caps });
        this.state = {};
    }
    render() {
        var _a;
        const { disabled, onType, border = true, className, layout = GermanKeyboardLayout, sideKeys = [] } = this.props;
        const { alt, caps } = this.state;
        const keyMap = (alt && !caps && layout.alt)
            || (alt && caps && toCaps((_a = layout.alt) !== null && _a !== void 0 ? _a : []))
            || (caps && (layout.caps || toCaps(layout.rows)))
            || layout.rows;
        return (React.createElement("div", { className: classNames(styles.keyboard, className) },
            React.createElement("div", { className: sideKeys.length > 0 ? styles.keyboardWidthReduced : undefined }, keyMap.map((row, index) => (React.createElement("div", { key: index, className: styles.row }, row.map((item, index) => {
                switch (item.kind) {
                    case "key":
                        return (React.createElement(KeyButton, { key: index, value: item.value, disabled: disabled, onType: onType, border: border, className: classes(styles.button, getKeyWidthStyle(item.width)) }, item.icon ? React.createElement(MaterialIcon, { icon: item.icon }) : item.value));
                    case "spacer":
                        return (React.createElement("div", { key: index, className: classes(styles.spacer, getKeyWidthStyle(item.width)) }));
                    case "alt":
                        return (React.createElement(KeyButton, { key: index, value: "alt", disabled: disabled, onType: this.handleAlt, border: border, className: classes(styles.button, alt && styles.buttonActive, getKeyWidthStyle(item.width)) },
                            React.createElement("span", { className: styles.altText }, "123")));
                    case "caps":
                        return (React.createElement(KeyButton, { key: index, value: "caps", disabled: disabled, border: border, onType: this.handleCaps, className: classes(styles.button, caps && styles.buttonActive, getKeyWidthStyle(item.width)) }, "\u21E7"));
                    case "abc":
                        return (React.createElement(KeyButton, { key: index, value: "ABC", disabled: disabled, onType: this.handleAlt, border: border, className: classes(styles.button, alt && styles.buttonActive, getKeyWidthStyle(item.width)) },
                            React.createElement("span", { className: styles.altText }, "abc")));
                }
            }))))),
            sideKeys.length > 0 && (React.createElement("div", { className: styles.keyboardSideKeys }, sideKeys
                .map(v => key(v))
                .map((item, index) => (React.createElement(KeyButton, { key: index, value: item.value, disabled: disabled, onType: onType, border: border, className: classes(styles.button, styles.buttonSide) }, item.value)))))));
    }
}
function getKeyWidthStyle(width) {
    switch (width) {
        case 0.5:
            return styles.widthHalf;
        case 1.5:
            return styles.width1andHalf;
        case 2:
            return styles.width2;
        case 3:
            return styles.width3;
        case 4:
            return styles.width4;
        case 1:
        default:
            return styles.width1;
    }
}
const styles = stylesheet({
    keyboard: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    keyboardSideKeys: {
        display: "flex",
        flexDirection: 'column',
        justifyContent: 'center',
        rowGap: '1em',
        flexGrow: 1,
        padding: '0.2rem 0'
    },
    keyboardWidthReduced: {
        $nest: {
            ' button': {
                width: '3.5rem'
            }
        }
    },
    row: {
        display: "flex",
        flexFlow: "row nowrap",
        justifyContent: "center",
        padding: "0.2em 0"
    },
    button: {
        flex: "0 0 auto",
        fontSize: "2em",
        padding: "0.2em 0",
        margin: "0 0.2rem",
        textAlign: "center",
        $nest: {
            "&:active": {
                backgroundColor: "rgba(255, 255, 255, 0.5)",
            }
        }
    },
    buttonSide: {
        width: 'auto',
        fontSize: '1.5rem',
    },
    buttonActive: {
        backgroundColor: "#eee",
        color: "#444",
    },
    altText: {
        fontSize: "1rem",
        fontWeight: 500,
    },
    widthHalf: {
        width: rem(2),
    },
    width1: {
        width: rem(4),
    },
    width1andHalf: {
        width: rem(6),
    },
    width2: {
        width: rem(8),
    },
    width3: {
        width: rem(12),
    },
    width4: {
        width: rem(16),
    },
    spacer: {
        flex: "0 0 auto",
        margin: "0 0.2rem",
        height: "2rem"
    }
});
//# sourceMappingURL=Keyboard.js.map